import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "datahtml"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_public_heade = _resolveComponent("public_heade");
  const _component_router_view = _resolveComponent("router-view");
  const _component_public_bottom = _resolveComponent("public_bottom");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_public_heade), _createVNode(_component_router_view), _createVNode(_component_public_bottom)]);
}